function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 24.18934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2-2",
    "data-name": "Ebene 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24.18934H0v-24H11.5a6.92919,6.92919,0,0,0-2,.3,11.98442,11.98442,0,0,0,2.5,23.7Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.1 14.989 16.1 16.989 8.3 16.989 8.3 14.989 13.3 9.089 8.5 9.089 8.5 7.089 16 7.089 16 9.089 11 14.989 16.1 14.989",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5.18934h-.2a12.04591,12.04591,0,0,0-9.6,9.6,1.31964,1.31964,0,0,1-1.4,1.1h-.1a1.41043,1.41043,0,0,1-1.4-1.1v-.3a11.688,11.688,0,0,0-10.9-9.3Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4,24.18934H12a12.07033,12.07033,0,0,0,11.7-9.5l.1-.3a1.38071,1.38071,0,0,1,1.3-1,1.41787,1.41787,0,0,1,1.5,1.2A12.08394,12.08394,0,0,0,38.4,24.18934Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,.18934a11.71178,11.71178,0,0,0-11.7,9.3l-.1.4a1.50209,1.50209,0,0,1-1.5,1.1,1.41043,1.41043,0,0,1-1.4-1.1.90151.90151,0,0,1-.1-.5,11.36668,11.36668,0,0,0-9.4-9.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,.18934v24H38.5a11.70146,11.70146,0,0,0,11.6-9.3l.1-.4a1.41043,1.41043,0,0,1,1.4-1.1,1.62523,1.62523,0,0,1,1.5,1.1l.1.4a12.39194,12.39194,0,0,0,11.8,9.3c6.2,0,12-5,12-11.3,0-7.5-5.4-12.7-12-12.7Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5.18934h4.3A12.41672,12.41672,0,0,0,36.5.18934Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,.18934a11.71178,11.71178,0,0,0-11.7,9.3l-.1.4a1.50209,1.50209,0,0,1-1.5,1.1,1.41043,1.41043,0,0,1-1.4-1.1.90151.90151,0,0,1-.1-.5,11.36668,11.36668,0,0,0-9.4-9.2H36.3a12.04591,12.04591,0,0,0-9.6,9.6,1.31964,1.31964,0,0,1-1.4,1.1h-.1a1.41043,1.41043,0,0,1-1.4-1.1v-.3a11.688,11.688,0,0,0-10.9-9.3H11.6a6.92919,6.92919,0,0,0-2,.3,11.973,11.973,0,0,0,2.4,23.7h0a12.07033,12.07033,0,0,0,11.7-9.5l.1-.3a1.38071,1.38071,0,0,1,1.3-1,1.41787,1.41787,0,0,1,1.5,1.2,12.08394,12.08394,0,0,0,11.8,9.6h.1a11.70146,11.70146,0,0,0,11.6-9.3l.1-.4a1.41043,1.41043,0,0,1,1.4-1.1,1.62523,1.62523,0,0,1,1.5,1.1l.1.4a12.39194,12.39194,0,0,0,11.8,9.3c6.2,0,12-5,12-11.3C77,5.38934,71.6.18934,65,.18934Zm-48.9,16.8H8.3v-2l5-5.9H8.5v-2H16v2l-5,5.9h5.1Zm22.4.4a5.30093,5.30093,0,1,1,5.4-5.3A5.35684,5.35684,0,0,1,38.5,17.38934Zm30.3-2.3a2.17761,2.17761,0,0,1-.7.9,2.28107,2.28107,0,0,1-1.2.6,4.14488,4.14488,0,0,1-1.6.2H61.4v-9.7H65a7.93076,7.93076,0,0,1,1.7.2,3.33722,3.33722,0,0,1,1.2.5,2.69569,2.69569,0,0,1,.7.8,3.59492,3.59492,0,0,1,.2,1.1,1.26834,1.26834,0,0,1-.1.6l-.3.6c-.1.2-.3.3-.5.5a2.01,2.01,0,0,1-.8.4,2.73344,2.73344,0,0,1,1.4.8,1.901,1.901,0,0,1,.5,1.3A1.63655,1.63655,0,0,1,68.8,15.08934Zm-3.4-2.4H63.8v2.5h1.6s1.5.1,1.5-1.3C66.8,12.68934,65.4,12.68934,65.4,12.68934Zm1.2-2.7c0-1.3-1.5-1.2-1.5-1.2H63.8v2.4H65C65.4,11.18934,66.6,11.28934,66.6,9.98934Z",
    style: {
      fill: "#353535"
    }
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 12.08934,
    rx: 3.1,
    ry: 3.2,
    style: {
      fill: "#353535"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZob);
export default __webpack_public_path__ + "static/media/zob.dbe06cbd3e50dbbf18b9848d552344cf.svg";
export { ForwardRef as ReactComponent };